<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form :form="form" layout="inline" :labelCol="{ style: { width: '100px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="周计划版本" :help="null">
              <global-select
                v-decorator="['scheduleNameList', { rules: [{ required: true }] }]"
                selectType="selectMultiple"
                requestApi="/scp/scpMrpScheduleNames/scheduleNameBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <!-- <a-col :md="6" :sm="24">
            <a-form-item label="计划版本" :help="null">
              <global-select
                v-decorator="['scheduleVersion', { rules: [{ required: true }] }]"
                selectType="selectAssemble"
                requestApi="/scp/scpSopMpsPlans/versionBox"
                :selectItem="{ value: 'realValue', label: 'label', thirdLabel: 'bringOutDataOne', thirdLabelText: '最新版本' }"
              />
            </a-form-item>
          </a-col> -->
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="handleExport" v-hasPermi="['scp:scpMrpScheduleDates:export']">导出</a-button>
      <a-button @click="importExcelHandleOpen" type="primary" v-hasPermi="['scp:scpMrpScheduleDates:import']">导入</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 2300 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.DMS_MPS_ITEM_LIST, // 表格方案配置唯一值
              }"
        >
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text, record }">
            <div :key="item.dataIndex">
              <span v-if="item.dataIndex === 'operation'">
                <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record)" v-hasPermi="['scp:scpMrpScheduleDates:edit']">编辑</a>
                <a v-if="!isEdit || currentId !== record.id" @click="handleDelete(record)" v-hasPermi="['scp:scpMrpScheduleDates:remove']" class="ml10">删除</a>
                <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
                <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
              </span>
              <span v-else-if="item.type === 'input'">
                <span v-if="!isEdit || currentId !== record.id">{{ record[item.dataIndex] }}</span>
                <a-input v-if="isEdit && currentId === record.id" v-model="record[item.dataIndex]" size="small" />
              </span>
              <span v-else-if="item.type === 'inputNumber'">
                <span v-if="!isEdit || currentId !== record.id">{{ record[item.dataIndex] }}</span>
                <a-input-number v-if="isEdit && currentId === record.id" v-model="record[item.dataIndex]" :min="0" :parser="value =>value.replace(/^\D*(\d*(?:\.\d{0,5})?).*$/g,'$1')" size="small" />
              </span>
              <span v-else-if="item.type === 'date'">
                <span v-if="!isEdit || currentId !== record.id">{{ text && $moment(text).format('YYYY-MM-DD') }}</span>
                <a-date-picker v-if="isEdit && currentId === record.id" v-model="record[item.dataIndex]" size="small" valueFormat="YYYY-MM-DD HH:mm:ss" />
              </span>
              <span v-else-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else>{{ text }}</span>
            </div>
          </template>
        </ls-api-table>
        <!-- 上传文件 -->
        <a-modal
          :title="upload.title"
          :visible="excelVisible"
          @ok="importExcelHandleCancel"
          @cancel="importExcelHandleCancel"
        >
          <a-upload-dragger
            name="file"
            accept=".xlsx, .xls"
            :multiple="true"
            :headers="upload.headers"
            :action="upload.url + '?updateSupport=' + upload.updateSupport"
            @change="importExcelHandleChange"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">
              请将文件拖拽到此处上传
            </p>
            <p class="ant-upload-hint">
              支持单个或批量上传，也可以点击后选择文件上传
            </p>
          </a-upload-dragger>
        </a-modal>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { apiUpdateScpMrpScheduleDates, apiDelScpMrpScheduleDates, apiScpMrpScheduleDatesList } from '@/api/scp/mrp-result-query/dms-mps-item'
import { generateLsTableResData } from '@/utils/util.js';
import Cookies from 'js-cookie';
export default {
  // eslint-disable-next-line
  name: 'Dms-mps-item', // name要和rms配置菜单路由保存一致(首字母大写)
  components: {},
  data () {
    const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get('Admin-Token')
    const Authorization = token ? 'Bearer ' + token : undefined;
    return {
      // 导入excel
      excelVisible: false,
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '导入Excel',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Authorization: Authorization },
        // 上传的地址
        url: process.env.VUE_APP_API_BASE_URL + '/scp/scpMrpScheduleDates/import'
      },
       // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiScpMrpScheduleDatesList, true),
        pageCurrent: true
      },
      isEdit: false,
      currentId: "",
      // 控制搜索展开
      advanced: true,
      // 查询参数
      form: this.$form.createForm(this),
      // 表格数据
      tableList: [],
      // 表格字段
      columns: [
        {
          title: '组织',
          dataIndex: 'organizationName',
          align: 'center',
          width: 120,
          stickyFixed: 'left'
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          align: 'center',
          width: 140,
          stickyFixed: 'left',
          ellipsis: true
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          align: 'center'
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          align: 'center',
          ellipsis: true
        },
        {
          title: '供应商编码',
          dataIndex: 'supplierCode',
          align: 'center'
        },
        {
          title: '供应商名称',
          dataIndex: 'supplierName',
          align: 'center'
        },
        {
          title: '大货类型',
          width: 140,
          dataIndex: 'orderType',
          scopedSlots: { customRender: 'orderType' },
          ellipsis: true,
          type: "input",
          align: 'center'
        },
        {
          title: '计划日期',
          dataIndex: 'scheduleDateNoMin',
          scopedSlots: { customRender: 'scheduleDateNoMin' },
          align: 'center',
          type: "date",
          width: 170
        },
        {
          title: '数量',
          dataIndex: 'scheduleQuantity',
          scopedSlots: { customRender: 'scheduleQuantity' },
          align: 'center',
          type: "inputNumber"
        },
        {
          title: '备注',
          dataIndex: 'scheduleComments',
          scopedSlots: { customRender: 'scheduleComments' },
          ellipsis: true,
          align: 'center',
          type: "input"
        },
        {
          title: '周计划版本',
          dataIndex: 'scheduleName',
          align: 'center'
        },
        {
          title: '计划版本',
          dataIndex: 'scheduleVersion',
          align: 'center'
        },
        {
          title: '更新人',
          dataIndex: 'updateName',
          align: 'center'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 160,
          align: 'center',
          type: "text"
        },
        {
          title: '创建人',
          dataIndex: 'createName',
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 160,
          align: 'center',
          type: "text"
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ]
    }
  },
  created () {},
  mounted () {
    this.onSearch()
  },
  methods: {
    // 表单搜索
    onSearch () {
      if (!this.form.getFieldsValue().scheduleNameList || this.form.getFieldsValue().scheduleNameList.length === 0) {
        this.$message.warning('计划名称不能为空')
        return;
      }
      this.isEdit = false;
      this.$refs.dataTable.searchParams = this.form.getFieldsValue();
      this.$refs.dataTable.getData();
    },
    // 删除
    handleDelete (row) {
      const self = this
      this.$confirm({
        title: '警告',
        content: `你确定要删除这行数据吗？`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          apiDelScpMrpScheduleDates(row.id).then((response) => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.columns = JSON.parse(JSON.stringify(this.columns))
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 编辑-保存
    handleSave (record) {
      if(!record.orderType) {
        this.$message.error("请填写大货类型")
        return false
      }
      apiUpdateScpMrpScheduleDates(record).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          this.isEdit = false
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 取消
    handleCancel (record) {
      this.isEdit = false
      this.onSearch()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.form.resetFields()
      this.handleQuery()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 导入excel */
    importExcelHandleChange (info) {
      const status = info.file.status
      if (status !== 'uploading') {
      }
      if (status === 'done') {
        this.$message.success(`${info.file.name}: ${info.file.response.msg}`)
      } else if (status === 'error') {
        this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
      }
    },
    /** 导入excel窗体关闭 */
    importExcelHandleCancel (e) {
      this.excelVisible = false
      // 关闭后刷新列表
      this.handleQuery()
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen (e) {
      this.excelVisible = true
    },
    /** 导出按钮操作 */
    handleExport () {
      this.download('scp/scpMrpScheduleDates/export', {
        ...this.form.getFieldsValue()
      }, `MDS/MPS条目_${new Date().getTime()}.xlsx`)
    }
  }
}
</script>

<style scoped lang="less">
</style>
